import React, { useState, useEffect } from "react";
import styles from "../styles.module.css";

const InviteCompany = () => {
  const [emails, setEmails] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // State for fetching existing companies
  const [companies, setCompanies] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableError, setTableError] = useState("");

  // Fetch companies on mount
  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setTableLoading(true);
    setTableError("");

    try {
      // Get admin email from localStorage
      const adminEmail = localStorage.getItem("adminemail") || "";

      // Use fetch instead of axios
      const response = await fetch("https://casaahaanahotels.com/sb_showcompanyusers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ adminemail: adminEmail })
      });

      // We can read JSON here because it's presumably a same-origin or CORS-enabled endpoint
      if (!response.ok) {
        throw new Error(`Network response was not ok (status: ${response.status})`);
      }

      const data = await response.json();
      if (data && data.user_data) {
        setCompanies(data.user_data);
      } else {
        setTableError("No companies found.");
      }
    } catch (error) {
      setTableError(`Error fetching companies: ${error.message}`);
    } finally {
      setTableLoading(false);
    }
  };

  const handleSendInvitation = async () => {
    if (!emails.trim()) {
      setErrorMessage("Please enter at least one email address.");
      return;
    }

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    // Split and trim each email
    const emailList = emails.split(",").map((email) => email.trim());

    // HTML content for the email
    const message = `
      <body style='font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0'>
        <div style='width:70%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px;text-align:center'>
          <div style='margin-bottom:20px'>
            <img src='https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg' alt='Company Logo' style='width:auto;height:100px;'>
          </div>
          <div style='text-align:left;line-height:1.6'>
            <h4 style='margin-top:0'>Star Behaviors - Company Invitation</h4>
            <p style='font-size:16px;'>Hello,</p>
            <p style='font-size:16px;'>
              We’d love for you to add your company to Star Behaviors! Our platform enables you to create, assign, and
              manage behavioral assessments seamlessly.
            </p>
            <p style='font-size:16px;'>
              <b>Next Steps:</b><br />
              1) Click the link below to register or add your company.<br />
              2) Follow the instructions provided to set up your account.<br />
            </p>
            <p style='font-size:16px;'>
              <a href='https://star.brandingbrandz.in/register' style='color:#06c;text-decoration:none'>
                Register / Add Your Company
              </a>
            </p>
            <p style='font-size:16px;'>
              Thank you for choosing Star Behaviors!
            </p>
          </div>
          <div style='margin-top:20px;font-size:.9em;color:#555'>
            Star Behaviors Support
          </div>
        </div>
      </body>
    `;

    let allSuccess = true;

    // Send each email individually
    for (const singleEmail of emailList) {
      try {
        const payload = {
          email: singleEmail,
          name: "Star Behaviors",
          subject: "Invitation to Add Your Company to Star Behaviors",
          message: message
        };

        // In no-cors mode, we can't read the response. We'll assume success if no network error.
        await fetch("https://bakemywords.com/mailchimp/sendmail.php", {
          method: "POST",
          mode: "no-cors", // <-- no-cors
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        // If we reach here, no network error occurred. We assume success.
      } catch (err) {
        allSuccess = false;
        setErrorMessage(`Error sending to ${singleEmail}: ${err.message}`);
        break; // Stop sending subsequent emails
      }
    }

    if (allSuccess) {
      setSuccessMessage("Invitations sent successfully!");
    }

    setLoading(false);
  };

  return (
    <div className={styles.pageContainer}>
      {/* Invitation Form */}
      <div className={styles.formContainer}>
        <h2 className={styles.formTitle}>Invite Companies to Star Behaviors</h2>
        <form className={styles.assignForm}>
          <div className={styles.formRow}>
            <label className={styles.formLabel}>
              Company Admin Emails <span>(comma separated)</span>:
            </label>
            <textarea
              rows="4"
              value={emails}
              onChange={(e) => setEmails(e.target.value)}
              placeholder="Enter one or more emails separated by commas"
              className={styles.textArea}
            />
          </div>

          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={handleSendInvitation}
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Invitation"}
            </button>
          </div>

          {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
        </form>
      </div>

      {/* Companies Table */}
      <div className={styles.tableContainer}>
        <h2 className={styles.tableTitle}>Companies Already in Star Behaviors</h2>

        {tableLoading ? (
          <p>Loading companies...</p>
        ) : tableError ? (
          <p className={styles.errorMessage}>{tableError}</p>
        ) : companies.length === 0 ? (
          <p>No companies found.</p>
        ) : (
          <table className={styles.companiesTable}>
            <thead>
              <tr>
                <th>Company Name</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((company, index) => (
                <tr key={index}>
                  <td>{company.companyname || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default InviteCompany;
